"use client"
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import React from "react";
// import { useThemeMode } from "@/hooks/useThemeMode";

export interface SwitchDarkModeProps {
  className?: string;
}
const SwitchDarkMode: React.FC<SwitchDarkModeProps> = ({ className = "" }) => {
  const { setTheme } = useTheme()
  // const { _toogleDarkMode, isDarkMode, toDark, toLight } = useThemeMode();


  return (
    <button
      // onClick={_toogleDarkMode}
      className={`text-2xl md:text-3xl w-12 h-12 rounded-full text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800 focus:outline-none flex items-center justify-center ${className}`}
      onClick={() => setTheme((prev)=> prev === 'dark' ? 'light' : 'dark')}
    >
      <span className="sr-only">Enable dark mode</span>
     {/* {renderDarkIcon()} */}
     <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
     <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </button>
  );
};

export default SwitchDarkMode;
